import { generatePath, Link } from 'react-router'

import { URL_PAGE_CATALOG_1ST_LVL } from '@shared/contants'
import {
  CategoriesBranchQuery,
  CategoriesPreviewQuery,
} from '@shared/generated'
import { cn } from '@shared/lib/cn'

import styles from './styles.module.scss'

interface CategoryChildrensProps {
  items:
    | CategoriesBranchQuery['categoriesBranch']
    | CategoriesPreviewQuery['categories'];
  activeChildSlug?: string;
}

export default function CategoryChildrens (props: CategoryChildrensProps) {
  const { items, activeChildSlug } = props

  const makePath = (slug: string) => generatePath(URL_PAGE_CATALOG_1ST_LVL, {
    categorySlug: slug,
  })

  return (
    <div className={styles.root}>
      {items &&
        items.map((item) => {
          if (!item) return null

          const isActive = item.slug === activeChildSlug

          return (
            <Link
              className={cn(
                styles['root__link'],
                isActive && styles['root__link--active'],
              )}
              to={makePath(item?.slug as string)}
              key={item?.id}
            >
              {item?.name}
            </Link>
          )
        })}
    </div>
  )
}
